import { render, staticRenderFns } from "./DetailPlayback.vue?vue&type=template&id=5f7f7fca&scoped=true"
import script from "./DetailPlayback.vue?vue&type=script&lang=js"
export * from "./DetailPlayback.vue?vue&type=script&lang=js"
import style0 from "./DetailPlayback.vue?vue&type=style&index=0&id=5f7f7fca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7f7fca",
  null
  
)

export default component.exports